import axios from 'axios';

const myApi = axios.create({
    baseURL: '/api-v2',
  });

export default {
  getIdiomas() {
    return myApi
      .get('/idiomas')
      .then(response => response.data);
  },
  g(key,lang) {
    return myApi
      .post('/lang-g',null,{params:{key:key,lang:lang}})
      .then(response => response.data);
  },
};